import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { memberApi } from '@formosa/shared/api/member';
import { resolveNewsApiLang } from '@formosa/shared/utils/newsLang';
import { useTranslation } from '../../i18n/LocaleContext';

export default function HelpCenterDetailPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { locale, t } = useTranslation();
  const [detail, setDetail] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!id) {
      return undefined;
    }
    let cancelled = false;

    async function load() {
      setLoading(true);
      setError('');
      try {
        const data = await memberApi.helpCenterDetail(id, { lang: resolveNewsApiLang(locale) });
        if (!cancelled) {
          setDetail(data);
        }
      } catch (err) {
        if (!cancelled) {
          setError(err.message || t('helpCenter.loadFailed'));
          setDetail(null);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    }

    load();
    return () => {
      cancelled = true;
    };
  }, [id, locale, t]);

  return (
    <div className="help-center-detail-page">
      <header className="help-center-detail-page__header">
        <button
          type="button"
          className="help-center-detail-page__back"
          aria-label={t('common.back')}
          onClick={() => navigate(-1)}
        >
          ‹
        </button>
        <h1 className="help-center-detail-page__nav-title">{t('helpCenter.title')}</h1>
      </header>

      <div className="help-center-detail-page__body">
        {loading ? <p className="help-center-page__status">{t('common.loading')}</p> : null}
        {error ? <p className="help-center-page__status help-center-page__status--error">{error}</p> : null}
        {!loading && !error && detail ? (
          <article className="help-center-detail">
            <h2 className="help-center-detail__title">
              <span className="help-center-page__section-accent" aria-hidden />
              {detail.title}
            </h2>
            <div
              className="help-center-detail__content"
              dangerouslySetInnerHTML={{ __html: detail.body || '' }}
            />
          </article>
        ) : null}
      </div>
    </div>
  );
}
